import Location from './location';
import { PATH_ACCOUNT_LOGOFF, PATH_LOGIN_LOGOUT } from '@defi/core-constants';
let Logout = {
  logout() {
    // include the loanApplicationID param to indicate which that needs to be unlocked before logging them out
    if (Location.pathname().indexOf("logout") > -1) Location.redirect(PATH_ACCOUNT_LOGOFF);else {
      Location.redirectWithReturnUrl(PATH_ACCOUNT_LOGOFF);
    }
  },
  logoutForced() {
    Location.redirect("".concat(PATH_ACCOUNT_LOGOFF, "?forced=true"));
  },
  logoutDirectlyToNewLogout() {
    Location.redirect(PATH_LOGIN_LOGOUT);
  }
};
export default Logout;